import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'

export function RevenueFeeTooltip(props: {
  revenueFeeApplied: number
  color?: string
}) {
  if (props.revenueFeeApplied === 0) {
    return null
  }

  return (
    <TextTooltip text={`Suma je očistená o poplatok.`} color={props.color} />
  )
}
